let _profile = {
	Credentials: {
		Login: null,
		Password: null,
		ex: {
			passwordRepeat: null
		}
	},
	Contact: {
		Email: null,
		Mobile: null,
		GivenName: null,
		LastName: null,
		Street: null,
		PostalCode: null,
		City: null
	}
};

export default _profile;